import { render } from "./CollapsableFieldSet.vue?vue&type=template&id=66790c0e"
import script from "./CollapsableFieldSet.vue?vue&type=script&lang=js"
export * from "./CollapsableFieldSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__